import type { QueryClient } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import type { Service } from "../service";

import type { GET_ALL } from "./common";
import { QUERY_KEYS } from "./common";

import { throwify } from "~/shared/fp";
import { useTranslation2 } from "~/shared/i18n";
import type { GetQueryOptions, InferQueryGenerics } from "~/shared/tanstack-query";

type UseGetAllGenerics = InferQueryGenerics<
  Service[typeof GET_ALL],
  ReturnType<(typeof QUERY_KEYS)[typeof GET_ALL]>["queryKey"]
>;
type UseGetAllOptions = GetQueryOptions<UseGetAllGenerics>;

function useGetAll(
  service: Service,
  options?: Omit<UseGetAllOptions, "queryKey" | "queryFn">,
  queryClient?: QueryClient,
) {
  const {
    translation: {
      i18n: { language },
    },
  } = useTranslation2();

  return useQuery(
    {
      ...options,
      ...QUERY_KEYS.getAll(language),
      queryFn: async () => throwify(await service.getAll()()),
    } as UseGetAllOptions,
    queryClient,
  );
}

export { useGetAll };
